/**
 * Enumeration of supported languages in the application.
 * Used to determine translation texts by the TranslationProvider.
 */
export enum SupportedLanguages {
    de = 'de',
    en = 'en',
}
